import { Component, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: "parent-events-row-header",
  templateUrl: "./parent-events-row-header.component.html",
  styleUrls: [
    "../parent-events-row/parent-events-row.component.scss",
    "./parent-events-row-header.component.scss",
  ],
})
export class ParentEventsRowHeaderComponent {
  public parentEvent: any = {
    eventCode: "קוד ארוע",
    eventName: "שם הארוע",
    registeredChildren: "רשומים",
    prices: "מחירים",
    eventStatus: "",
    RegistrationEndDate: "תאריך סגירת הרשמה",
    eventOpenTo: "למי פתוח הארוע",
  };
  @Input("indentToScrollBar") public indentToScrollBar: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-row-header/parent-events-row-header.component.ts